<template>
  <button @click="onClick" class="widget-asc-desc">
    <img v-if="type == 1" src="@/assets/icon/asc.svg" />
    <img v-else src="@/assets/icon/desc.svg" />
  </button>
</template>

<script>
export default {
  name: "widget_button",
  props: {},
  data() {
    return {
      type: 1,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    onClick() {
      let vm = this;
      if (vm.type == 1) {
        vm.type = 2;
        vm.$emit("click", "desc");
      } else {
        vm.type = 1;
        vm.$emit("click", "asc");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.widget-asc-desc {
  background: transparent;
  border: none;
  font-style: bold !important;
  font-weight: 500;
  width: min-content;
  position: relative;
  cursor: pointer;
}
</style>
